export default {
    props: {
        borderColor: {
            type: String,
            default: undefined,
            kComposite: 'border.color'
        }, 
        borderDashType: {
            type: String,
            default: undefined,
            kComposite: 'border.dashType'
        }, 
        borderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'border.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoBarcode/Border.js